<template>
    <v-flex @click="scrollTo()"  v-ripple md11 class="pa-2 folyamat-sav-link-parent" :style="getStyle">
        <span class="folyamat-sav-item" :style="getLinkStyle">
           {{ label }}
        </span>
        <v-icon class="check-mark" color="primary" v-if="finished"> check </v-icon>
    </v-flex>
</template>

<script>
import { COLOR_TYPE } from '../../modules/AppTheme';
import EventBus from '../../modules/EventBus';
import { scrollToElementByIdWithOffset } from '../../modules/SaveErrorHandler';

export default {
    name: 'BnSideBarNavLink',
    props: {
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        onScreenId: {
            type: String,
            default: null,
        },
        index: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            finished: false,
        };
    },
    methods: {
        scrollTo() {
            EventBus.$emit('set-sidebar-link-selected', this.id);
            if (this.index === 0) {
                scrollToElementByIdWithOffset('top', 150);
            } else {
                scrollToElementByIdWithOffset(this.id, 150);
            }
        },
    },

    mounted() {
        EventBus.$on('set-anchor-finished-status', ({ status, id }) => {
            if (this.id === id) {
                this.finished = status;
            }
        });
    },

    computed: {
        getStyle() {
            return this.onScreenId === this.id ? 'background-color: #edefeb;' : '';
        },

        getLinkStyle() {
            return `color: ${this.$theme.getColor(COLOR_TYPE.PRIMARY)};`;
        },
    },

};
</script>

<style scoped>
    .folyamat-sav-item {
        cursor: pointer;
        font-size: 16px;
        font-weight: bold;
    }
    .folyamat-sav-link-parent:hover {
        background-color: #edefeb;
        cursor: pointer;
    }

    .check-mark {
        float: right;
    }
</style>
